"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSubscriptionsControllerGetAccessibleSportsV1200Response = instanceOfSubscriptionsControllerGetAccessibleSportsV1200Response;
exports.SubscriptionsControllerGetAccessibleSportsV1200ResponseFromJSON = SubscriptionsControllerGetAccessibleSportsV1200ResponseFromJSON;
exports.SubscriptionsControllerGetAccessibleSportsV1200ResponseFromJSONTyped = SubscriptionsControllerGetAccessibleSportsV1200ResponseFromJSONTyped;
exports.SubscriptionsControllerGetAccessibleSportsV1200ResponseToJSON = SubscriptionsControllerGetAccessibleSportsV1200ResponseToJSON;
exports.SubscriptionsControllerGetAccessibleSportsV1200ResponseToJSONTyped = SubscriptionsControllerGetAccessibleSportsV1200ResponseToJSONTyped;
var AccessibleSportsResponseDto_1 = require("./AccessibleSportsResponseDto");
/**
 * Check if a given object implements the SubscriptionsControllerGetAccessibleSportsV1200Response interface.
 */
function instanceOfSubscriptionsControllerGetAccessibleSportsV1200Response(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function SubscriptionsControllerGetAccessibleSportsV1200ResponseFromJSON(json) {
    return SubscriptionsControllerGetAccessibleSportsV1200ResponseFromJSONTyped(json, false);
}
function SubscriptionsControllerGetAccessibleSportsV1200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (0, AccessibleSportsResponseDto_1.AccessibleSportsResponseDtoFromJSON)(json['data']),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function SubscriptionsControllerGetAccessibleSportsV1200ResponseToJSON(json) {
    return SubscriptionsControllerGetAccessibleSportsV1200ResponseToJSONTyped(json, false);
}
function SubscriptionsControllerGetAccessibleSportsV1200ResponseToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': (0, AccessibleSportsResponseDto_1.AccessibleSportsResponseDtoToJSON)(value['data']),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
